import {Component, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';
import {CustomerService} from '../../../services/customers.service';
import {Customer} from '../../../models/customer.model';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {MaintenanceService} from '../../../services/maintenance.service';
import {Maintenance} from '../../../models/maintenance.model';

@Component({
  providers: [CustomerService, MaintenanceService],
  selector: 'app-customers-history',
  templateUrl: './customer.history.component.html',
})
export class CustomerHistoryComponent implements OnDestroy, OnInit {
  public customer: Customer;
  public maintenances: Maintenance[];

  private _selectedMaintenance: Maintenance;
  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute, private _customerService: CustomerService,  public router: Router,
              private _maintenanceService: MaintenanceService, private _elementReference: ElementRef) {}

  public ngOnInit() {
    this._route.params
      .takeUntil(this._ngUnSubscribe)
      .subscribe(params => {
        const customerId = params['id'];

        if (customerId) {
          this._customerService.load(customerId);
          this._customerService.customers$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              customers => {
                this.customer = customers.find(pr => pr._id === customerId);
              }
            );

          this._maintenanceService.loadAll(`?customer=${customerId}`);
          this._maintenanceService.maintenances$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              maintenances => {
                this.maintenances = maintenances;
              }
            );
        }
      });
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  set selectedMaintenance(value: Maintenance) {
    this._selectedMaintenance = value;
    this.detailsMaintenance();
  }
  get selectedMaintenance(): Maintenance {
    return this._selectedMaintenance;
  }

  public detailsMaintenance(): void {
    if (this.selectedMaintenance) {
      this.router.navigate(['/maintenances', this.selectedMaintenance._id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/customer/history/customer.history.component.ts